module.exports = __webpack_public_path__ + "static/media/jw_black.84a09dbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/bottles/backgrounds/General/jw_black.jpg
// module id = 715
// module chunks = 0